import api from "../../../services/api";

const BASE = "/api/risk-review";

const unwrap = (response) => {
  if (response?.data?.data !== undefined) return response.data.data;
  return response?.data;
};

export const riskReviewService = {
  getCreateOptions: async () =>
    unwrap(await api.get(`${BASE}/metadata/create-options`)),
  getWorkflowCriteriaOptions: async () =>
    unwrap(await api.get(`${BASE}/metadata/workflow-criteria-options`)),
  getWorkflowVersions: async ({ businessUnit, division, country, workflowId, workflowVersion }) =>
    unwrap(
      await api.get(`${BASE}/metadata/workflow-options`, {
        params: { businessUnit, division, country, workflowId, workflowVersion },
      }),
    ),
  getDashboardStats: async () => unwrap(await api.get(`${BASE}/dashboard/stats`)),
  getTemplates: async (params) => unwrap(await api.get(`${BASE}/templates`, { params })),
  getTemplate: async (id) => unwrap(await api.get(`${BASE}/templates/${id}`)),
  resolveTemplate: async (params) =>
    unwrap(await api.get(`${BASE}/templates/resolve`, { params })),
  createTemplate: async (payload) => unwrap(await api.post(`${BASE}/templates`, payload)),
  createTemplateVersion: async (id, payload = {}) =>
    unwrap(await api.post(`${BASE}/templates/${id}/versions`, payload)),
  updateTemplateVersion: async ({ templateId, versionId, payload }) =>
    unwrap(
      await api.patch(`${BASE}/templates/${templateId}/versions/${versionId}`, payload),
    ),
  publishTemplateVersion: async ({ templateId, versionId }) =>
    unwrap(
      await api.post(`${BASE}/templates/${templateId}/versions/${versionId}/publish`),
    ),
  getRequests: async (params) => unwrap(await api.get(`${BASE}/requests`, { params })),
  createRequest: async (payload) => unwrap(await api.post(`${BASE}/requests`, payload)),
  getRequest: async (id) => unwrap(await api.get(`${BASE}/requests/${id}`)),
  updateRequest: async ({ id, payload }) =>
    unwrap(await api.patch(`${BASE}/requests/${id}`, payload)),
  uploadAttachments: async ({ id, fieldCode, files }) => {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    formData.append("fieldCode", fieldCode);

    return unwrap(
      await api.post(`${BASE}/requests/${id}/upload-attachments`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }),
    );
  },
  submitRequest: async (id) => unwrap(await api.post(`${BASE}/requests/${id}/submit`)),
  createRevision: async (id) =>
    unwrap(await api.post(`${BASE}/requests/${id}/revisions`)),
  withdrawRequest: async (id) =>
    unwrap(await api.post(`${BASE}/requests/${id}/withdraw`)),
  getMyApprovals: async (params) =>
    unwrap(await api.get(`${BASE}/approvals/mine`, { params })),
  approve: async ({ id, comments }) =>
    unwrap(await api.post(`${BASE}/approvals/${id}/approve`, { comments })),
  reject: async ({ id, comments }) =>
    unwrap(await api.post(`${BASE}/approvals/${id}/reject`, { comments })),
  sendBack: async ({ requestId, comments }) =>
    unwrap(await api.post(`${BASE}/approvals/requests/${requestId}/send-back`, { comments })),
  approveByBench: async ({ requestId, comments }) =>
    unwrap(await api.post(`${BASE}/approvals/requests/${requestId}/approve-bench`, { comments })),
  bulkApprove: async (payload) =>
    unwrap(await api.post(`${BASE}/approvals/bulk-approve`, payload)),
  seedDefaultTemplate: async () =>
    unwrap(await api.post(`${BASE}/seed/default-template`)),
  health: async () => unwrap(await api.get(`${BASE}/health`)),
};

export default riskReviewService;
